<div mat-dialog-title class="flex flex-row items-center justify-between gap-4">
  <div i18n>Настройки столбцов таблицы</div>
  <button mat-icon-button [mat-dialog-close]="undefined">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="no-padding">
  <table class="simple">
    <thead>
      <tr>
        <th i18n>Колонка</th>
        <th i18n>Номер колонки</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td i18n>Позиция</td>
        <td>
          <mat-form-field class="dense-input w-full no-subscript no-label" appearance="outline">
            <input
              [disabled]="data.disabledForm"
              matInput
              type="number"
              cslDisableInputSpinEvents
              [(ngModel)]="data.columnFields.position" />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td i18n>Наименование</td>
        <td>
          <mat-form-field class="dense-input w-full no-subscript no-label" appearance="outline">
            <input
              [disabled]="data.disabledForm"
              type="number"
              cslDisableInputSpinEvents
              matInput
              [(ngModel)]="data.columnFields.name" />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td i18n>Длина</td>
        <td>
          <mat-form-field class="dense-input w-full no-subscript no-label" appearance="outline">
            <input
              [disabled]="data.disabledForm"
              type="number"
              cslDisableInputSpinEvents
              matInput
              [(ngModel)]="data.columnFields.length" />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td i18n>Ширина</td>
        <td>
          <mat-form-field class="dense-input w-full no-subscript no-label" appearance="outline">
            <input
              [disabled]="data.disabledForm"
              type="number"
              cslDisableInputSpinEvents
              matInput
              [(ngModel)]="data.columnFields.width" />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td i18n>Количество</td>
        <td>
          <mat-form-field class="dense-input w-full no-subscript no-label" appearance="outline">
            <input
              [disabled]="data.disabledForm"
              type="number"
              cslDisableInputSpinEvents
              matInput
              [(ngModel)]="data.columnFields.count" />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td i18n>Ориентация</td>
        <td>
          <mat-form-field class="dense-input w-full no-subscript no-label" appearance="outline">
            <input
              [disabled]="data.disabledForm"
              type="number"
              cslDisableInputSpinEvents
              matInput
              [(ngModel)]="data.columnFields.noOrientation" />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td i18n>Толщина L1</td>
        <td>
          <mat-form-field class="dense-input w-full no-subscript no-label" appearance="outline">
            <input
              [disabled]="data.disabledForm"
              type="number"
              cslDisableInputSpinEvents
              matInput
              [(ngModel)]="data.columnFields.thicknessL1" />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td i18n>Толщина L2</td>
        <td>
          <mat-form-field class="dense-input w-full no-subscript no-label" appearance="outline">
            <input
              [disabled]="data.disabledForm"
              type="number"
              cslDisableInputSpinEvents
              matInput
              [(ngModel)]="data.columnFields.thicknessL2" />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td i18n>Толщина W1</td>
        <td>
          <mat-form-field class="dense-input w-full no-subscript no-label" appearance="outline">
            <input
              [disabled]="data.disabledForm"
              type="number"
              cslDisableInputSpinEvents
              matInput
              [(ngModel)]="data.columnFields.thicknessW1" />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td i18n>Толщина W2</td>
        <td>
          <mat-form-field class="dense-input w-full no-subscript no-label" appearance="outline">
            <input
              [disabled]="data.disabledForm"
              type="number"
              cslDisableInputSpinEvents
              matInput
              [(ngModel)]="data.columnFields.thicknessW2" />
          </mat-form-field>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div mat-dialog-actions>
  <button i18n mat-raised-button class="mat-accent" [mat-dialog-close]="data.columnFields">ОК</button>
  <button i18n mat-button [mat-dialog-close]="undefined">ОТМЕНА</button>
</div>
